<template>
  <div>
    <v-app-bar style="background-image: linear-gradient(to right, #FFFFFF, #FFFFFF, #03429e);"
     dense dark app>
      <v-toolbar flat dense style="" class="ml-n3 transparent">
        <v-toolbar-title class="mr-4">
        </v-toolbar-title>
        <v-img
          style="cursor: pointer;"
          @click="gomanage()"
          src="@/assets/Meetlogo.svg"
          max-width="60px"
          class="app-bar-left"
        ></v-img>
      </v-toolbar>
      <v-col cols="2" md="2" sm="2" xs="2">
      <v-spacer>
        <span outlined class="float-right pr-12" style="cursor: pointer;font-family: Ebrima; font-size: 18px" @click="backhome" v-if="!gotoativate">
          {{$t("loginpage.login") }}
        </span>
      <div
      class="float-right"
      style=" font-style: normal; font-family: Ebrima; font-size: 14px"
      v-if="gotoativate">
          <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="pt-2 pb-3">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon dark color="#141D58" size="46"> mdi-account-circle </v-icon>
                <!-- <v-img size="46" :src="avatar" v-model="avatar" ></v-img> -->
              </v-list-item-avatar>
              <v-list-item-content
                v-if="
                  $vuetify.breakpoint.lg ||
                    $vuetify.breakpoint.md ||
                    $vuetify.breakpoint.xl
                "
              >
                <v-list-item-title
                  style="
                    font-size: 14px;
                    color: white;
                    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                  "
                >
                  {{ firstname }} {{ lastname }}</v-list-item-title
                >
                <v-list-item-subtitle
                  class="mt-2"
                  style="
                    font-size: 13px;
                    color: white;
                    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                  "
                  >Description Profile</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <v-list width="340px">
          <v-row no-gutters class="mt-2">
            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
            <v-col cols="10" md="10" sm="10" xs="10">
              <v-row no-gutters>
                <v-col cols="12" md="12" sm="12" xs="12">
                  <v-row no-gutters>
                    <v-col cols="3" md="3" sm="3" xs="3" align-self="center">
                      <v-avatar color="indigo" size="65">
                        <v-icon dark size="45"> mdi-account-circle </v-icon>
                      <!-- <v-img size="46" :src="avatar" v-model="avatar" ></v-img> -->
                      </v-avatar>
                    </v-col>
                    <v-col md="1"></v-col>
                    <v-col
                      cols="8"
                      md="8"
                      sm="8"
                      xs="8"
                      align-self="center"
                      align="left"
                    >
                      <span style="font-size: 16px; font-weight: bold; font-family: Kanit"
                        >{{ firstname }} {{ lastname }}</span
                      >
                       <div class="mt-2">
                        <v-btn
                          text
                          class="p-0 m-0 no-uppercase"
                          height="0"
                          color="#0078D6"
                          min-width="0"
                          style="font-family: Kanit; font-size: 15px"
                          @click="gomanage()"
                          >{{$t("managepage.rooms") }}</v-btn
                        >
                      </div>
                      <!-- <div class="mt-2">
                        <v-btn
                          text
                          class="p-0 m-0 no-uppercase"
                          height="0"
                          color="#0078D6"
                          min-width="0"
                          style="font-family: Kanit; font-size: 15px"
                          @click="opendialsetingprofile()"
                          >{{$t("upperpage.setingprofile") }}</v-btn
                        >
                      </div> -->
                      <!-- <div>
                        <v-btn
                          text
                          class="p-0 m-0 no-uppercase"
                          height="0"
                          color="#0078D6"
                          min-width="0"
                          style="font-family: Kanit; font-size: 15px"
                          @click="gotoativatepage"
                          >{{$t("activatepage.activate") }}</v-btn
                        >
                      </div> -->
                      <div>
                        <v-btn
                          text
                          class="p-0 m-0 no-uppercase"
                          height="0"
                          color="#0078D6"
                          min-width="0"
                          @click="logout()"
                          style="font-family: Kanit; font-size: 15px"
                          >{{$t("loginpage.logout") }}</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col cols="1" md="1" sm="1" xs="1"></v-col> -->
          </v-row>
          <v-divider class="p-0 m-0 pb-2 mt-4"></v-divider>
          <v-row no-gutters>
            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
            <v-col cols="10" md="10" sm="10" xs="10">
              <v-row no-gutters>
                <v-col cols="12" md="12" sm="12" xs="12">
                  <v-row no-gutters>
                    <v-col
                      cols="6"
                      md="6"
                      sm="6"
                      xs="6"
                      align-self="center"
                      align="left"
                      class="mt-n1"
                    > 
                      <v-row no-gutters>
                        <v-col
                          cols="3"
                          md="2"
                          sm="3"
                          xs="3"
                          align-self="center"
                        >
                          <v-img
                            src="@/assets/logoOne.png"
                            max-width="21px"
                            max-height="30px"
                          ></v-img>
                        </v-col>
                        <v-col
                          cols="9"
                          md="10"
                          sm="9"
                          xs="9"
                          align-self="center"
                        >
                          <span
                            style="
                              font-family: Sarabun;
                              font-size: 14px;
                              font-weight: 400;
                              color: #353535;
                            "
                            >ONE Conference</span
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col md="2"></v-col>
                    <v-col cols="6" md="4" sm="6" xs="6" class="text-right pt-8" @click="versiononecenf">
                      <!-- <span style="cursor: pointer;">
                        เวอร์ชั่น
                        <v-icon color="#00A4EA">mdi-information-outline</v-icon>
                      </span> -->
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-list>
      </v-menu>
      </div>
      <!-- </v-col> -->
        <!-- <span outlined class="float-right pr-3" style="cursor: pointer;font-family: Ebrima; font-size: 22px" @click="gotoativatepage" v-if="gotoativate">
          ACTIVATECODE
        </span> -->
        <!-- <span class="float-right" style="font-family: Sarabun; font-size: 22px">ONE Conference</span> -->
      </v-spacer>
    </v-col>
      <v-col md="2" lg="1" sm="2" xs="2">
              <div class="">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content style="cursor: pointer;">
                    <v-list-item-title v-bind="attrs" v-on="on" class="text-white">
                      <v-icon color="white" style="font-size: 1.25em;"
                      >mdi-web</v-icon>
                      <span> {{ $t("default") == 'th' ? 'TH' : 'EN'  }}</span>
                      </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list>
                  <v-list-item @click="change_languae('th')">
                      <v-img
                        src="@/assets/th.jpg"
                        max-width="18px"
                        max-height="18px"
                      ></v-img>
                      <span>ไทย</span>
                  </v-list-item>
                  <v-list-item @click="change_languae('en')">
                      <v-img
                        src="@/assets/en.png"
                        max-width="16px"
                        max-height="16px"
                      ></v-img>
                      English
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            </v-col>
    </v-app-bar>
    <v-card height="100%" v-if="($vuetify.breakpoint.xs )"
    class="articleM">
    <v-row no-gutters>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12" class="mt-12">
        </v-col>
        <v-row no-gutters>
          <v-col cols="2" md="2" xs="2" sm="2"></v-col>
          <!-- <v-col cols="1" md="1" xs="1" sm="1"> -->
            <!-- <v-img
          src="@/assets/logoOne.png"
          max-width="88px"
          max-height="154.73px"
          class="float-right"
        ></v-img> -->
          <!-- </v-col> -->
          <v-col cols="9" md="9" xs="9" sm="9" class="mt-2 text-left">
            <span style=" font-size: 36px;">
            ONE 
          </span>
          <span style=" font-size: 33px;">
            Meet 
          </span>
        <div style="font-size: 16px; font-weight: 250; line-height: 31.2px;">
          การให้บริการประชุมออนไลน์ที่ปลอดภัยและใช้งานได้ง่าย
        </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1" md="1" xs="1" sm="1" class="mb-4">
          </v-col>
          <v-col cols="10" md="10" xs="10" sm="10" class="mb-4">
            <v-row>
              <v-col cols="12" md="12" xs="12" sm="12">
                <input placeholder="ป้อนรหัสหรือลิ้งก์" v-model="coppylink" type="text" class="input" style="border-radius: 20px;">
              </v-col>
              <v-col cols="12" md="12" xs="12" sm="12">
              <v-btn  depressed
              rounded
              block
              style="color: white"
              @click="submit"
               color="#3D85C6">
               <v-icon>
                mdi-video-plus-outline
               </v-icon>
              {{$t("button.attendmeeting") }}
              </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12"  md="3" class="mb-4">
          </v-col>
      </v-row>
        <v-col class="mb-5" cols="12">
        </v-col>
      </v-row>
    </v-container>
    <router-view />
  </v-row>
    </v-card>
    <v-card height="1100" v-if="($vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.sm)"
    class="article">
    <v-row no-gutters>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12" class="mt-12">
        </v-col>
        <v-col>
        </v-col>
        <v-col class="mb-3 mt-5" cols="12">
        </v-col>
        <v-col class="mb-5" cols="12">
        </v-col>
        <!-- <v-col
          cols="12"
          align-self="center"
          align="center">
          <div class="mb-6">
          </div>
          <span style="color: #34495E; font-size: 46px;">
            One stop for global success 
          </span>
        </v-col> -->
        <v-row no-gutters>
          <v-col cols="4" md="3" xs="1" sm="1"></v-col>
          <!-- <v-col cols="1" md="1" xs="1" sm="1"> -->
            <!-- <v-img
          src="@/assets/Meetlogo.svg"
          max-width="120px"
          max-height="154.73px"
          class="float-right"
        ></v-img> -->
          <!-- </v-col> -->
          <v-col cols="6" md="6" xs="6" sm="6" class="mt-2 pl-6 text-left">
            <span style=" font-size: 45px;">
            ONE 
          </span>
          <span style=" font-size: 42px;">
            Meet
          </span>
            <!-- <div style="font-size: 34px; font-weight: 500; line-height: 44.2px;">
          Conference
        </div> -->
        <div style="font-size: 22px; font-weight: 500; line-height: 31.2px;">
          การให้บริการประชุมออนไลน์ที่ปลอดภัยและใช้งานได้ง่าย
        </div>
          </v-col>
        </v-row>
        <!-- <v-col
          cols="12"
          class="mt-n4"
          style="font-family: Sarabun"
          align-self="center"
          align="center">
          <div>
          </div>
          <span style="color: #34495E; font-size: 66px; font-weight: 600">
            ONE 
          </span>
          <span style="text-decoration: underline; color: #1565c0; font-size: 62px;">
            Conference 
          </span>
        </v-col> -->
        <!-- <v-col
          cols="12"
          class="mt-n"
          align-self="center"
          align="center">
          <div>
          </div>
          <span style="color: #34495E; font-size: 42px;">
            Connect with the rest of the world! 
          </span>
        </v-col> -->
        <v-row>
          <v-col cols="12" md="3" class="mb-4">
          </v-col>
          <v-col cols="12" md="6" class="mb-4">
            <div class="input-container">
              <v-btn  depressed
              rounded
              @click="submit"
              style="color: white"
               color="#3D85C6">
               <v-icon>
                mdi-video-plus-outline
               </v-icon>
               {{$t("joinpage.attendmeet") }}
              </v-btn>
              <p class="pr-2 pl-2"></p>
              <input :placeholder= "$t('joinpage.inputcode')" v-model="coppylink" type="text" class="input" style="border-radius: 20px;">
              <!-- <input placeholder="ป้อนรหัสหรือลิ้งก์" v-model="coppylink" type="text" class="input">
              <span  @click="submit">เข้าร่วมการประชุม</span> -->
          </div>
          </v-col>
          <v-col cols="12"  md="3" class="mb-4">
          </v-col>
      </v-row>
        <v-col class="mb-5" cols="12">
        </v-col>
        <v-col class="mb-5" cols="12">
        </v-col>
        <v-col class="mb-5" cols="12">
        </v-col>
        <v-col class="mb-5" cols="12">
        </v-col>
        <v-col class="mb-5" cols="12">
        </v-col>
        <v-col class="mb-5" cols="12">
        </v-col>
        <v-col class="mb-5" cols="12">
        </v-col>
      </v-row>
    </v-container>
    <router-view />
  </v-row>
    </v-card>
    <v-card height="1100" v-if="($vuetify.breakpoint.xl || $vuetify.breakpoint.xxl)"
    class="articleXL">
    <v-row no-gutters>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12" class="mt-12">
        </v-col>
        <v-col cols="12" class="mt-12">
        </v-col>
        <v-col cols="12" class="mt-12">
        </v-col>
        <v-col cols="12" class="mt-12">
        </v-col>
        <v-col cols="12" class="mt-12">
        </v-col>
        <v-row no-gutters>
          <v-col cols="2" md="2" xs="2" sm="2"></v-col>
          <!-- <v-col cols="1" md="1" xs="1" sm="1"> -->
            <!-- <v-img
          src="@/assets/logoOne.png"
          max-width="88px"
          max-height="154.73px"
          class="float-right"
        ></v-img> -->
          <!-- </v-col> -->
          <v-col cols="9" md="9" xs="9" sm="9" class="mt-2 text-left">
            <span style=" font-size: 44px;">
            ONE 
          </span>
          <span style=" font-size: 40px;">
            Meet 
          </span>
        <div style="font-size: 24px; font-weight: 250; line-height: 31.2px;">
          การให้บริการประชุมออนไลน์ที่ปลอดภัยและใช้งานได้ง่าย
        </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1" md="1" xs="1" sm="1" class="mb-4">
          </v-col>
          <v-col cols="10" md="10" xs="10" sm="10" class="mb-4">
            <v-row>
              <v-col cols="12" md="12" xs="12" sm="12">
                <input placeholder="ป้อนรหัสหรือลิ้งก์" v-model="coppylink" type="text" class="input" style="border-radius: 20px;">
              </v-col>
              <v-col cols="12" md="12" xs="12" sm="12">
              <v-btn
              rounded
              block
              @click="submit"
               color="primary">
               <v-icon>
                mdi-video-plus-outline
               </v-icon>
               {{$t("button.attendmeeting") }}
              </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12"  md="3" class="mb-4">
          </v-col> -->
      </v-row>
        <!-- <v-col class="mb-5" cols="12">
        </v-col> -->
      </v-row>
    </v-container>
    <router-view />
  </v-row>
    </v-card>
    <setingprofile :show="dialogshow" @close="dialogshow = false"/>
    <Footer />
</div>
  </template>

<script>
import { mapActions, mapState } from "vuex";
import Footer from "../Footerjoin.vue";
import setingprofile from "../dialog/setingprofile.vue";
export default {
  components: {
    Footer,
    setingprofile,
  },
  data() {
    return {
      coppylink: "",
      avatar: null,
      user_id: "",
      gotoativate: 0,
      dataareaonebox: "",
      used_storageaverage: 0,
      dialogshow: false,
      shownoroom: false,
      firstname: "",
      lastname: "",
      jwt: require("jsonwebtoken"),
    };
  },
  created() {
    if (localStorage.getItem("user-token") === null) {
      // console.log('null')
      this.gotoativate = 0;
    } else {
      // console.log('else')
      this.gotoativate = 1;
      this.decodetoken();
      // this.goPage("/manage");
    }
  },
  watch: {},
  methods: {
    backhome() {
      window.open("/", "_self");
    },
    gotoativatepage() {
      this.$router.push("/activate");
    },
    versiononecenf() {
      this.$swal.fire({
        title: "Version",
        text: `One Meeting Release version ${process.env.VUE_APP_VERSION_NUMBER} on ${process.env.VUE_APP_VERSION_DATE}`,
        icon: "info",
        showCancelButton: false,
        confirmButtonText: this.$t("button.btnok"),
        allowOutsideClick: false,
      });
    },
    change_languae(language) {
      // console.log(language);
      if (language === "th") {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
      } else if (language === "en") {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
      }
    },
    gomanage() {
      if (
        localStorage.getItem("user-token") === null ||
        localStorage.getItem("user-token") === ""
      ) {
        window.open("/", "_self");
      } else {
        window.open("/manage", "_self");
      }
    },
    getprofile() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/theme/get/" + this.user_id)
        .then((res) => {
          // console.log('res', res)
          // this.avatar = res.data.data.user.profile
          this.avatar = res.data.data.user.profile;
          // console.log('user_profile', this.avatar)
        })
        .catch((err) => {
          console.log("err getprofile", err);
        });
    },
    logout() {
      this.axios
        .delete(process.env.VUE_APP_API + "/api/lv1/auth/logout")
        .then((res) => {
          if (res.status === 200) {
            this.$swal(
              this.$t("loginpage.logout"),
              this.$t("loginpage.Successfully"),
              "success"
            ).then((result) => {
              localStorage.clear();
              localStorage.setItem("lang", "th");
              window.location.href = "/";
            });
          } else {
            console.log("ERRORlogout", res.data.message);
          }
        })
        .catch((e) => {
          console.log("ERRORlogout: ", e.result);
        });
    },
    decodetoken() {
      var token = localStorage.getItem("user-token");
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      var data = this.jwt.decode(decryptedText);
      this.userData = data;
      // console.log('this.userData', this.userData)
      this.user_id = this.userData.user._id;
      if (this.userData.user.room !== null) {
        this.role = "host";
        window.open("/manage", "_self");
      } else {
        this.role = "guest";
      }
      this.avatar = this.userData.user.avatar_profile;
      if (data.user.lastname === "") {
        this.firstname = data.user.email;
        this.lastname = "";
      } else {
        this.firstname = data.user.name;
        this.lastname = data.user.lastname;
      }
      this.refrestoken();
    },
    async refrestoken() {
      var token = localStorage.getItem("user-token");
      await this.axios
        .get(
          process.env.VUE_APP_API + "/api/lv1/auth/refreshtoken",
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("user-token"),
            },
          }
          // await this.axios.post(process.env.VUE_APP_API + '/api/v1/authentication/refrestoken', {
          //   headers: {
          //         Authorization: 'bearer ' + token
          //       }
          // }
        )
        .then((res) => {
          // console.log('sssss', res)
          this.getprofile();
        })
        .catch((err) => {
          this.$swal(this.$t("message.Sessiontimeout"), "", "warning").then((result) => {
            localStorage.clear();
            localStorage.setItem("lang", "th");
            window.open("/", "_self");
          });
        });
    },
    opendialsetingprofile() {
      this.dialogshow = true;
    },
    submit() {
      if (this.coppylink === "") {
        this.$swal(
          this.$t("joinpage.empty"),
          "",
          "warning"
        );
      } else {
        let texturl = this.coppylink;
        // console.log('texturl', texturl)
        const myarr = texturl.split("?");
        // console.log('myarr', myarr)
        if (myarr[1] === undefined) {
          // const arry2 = myarr[0].split("-")
          const arry = myarr[0].split("=");
          // console.log('arry', arry)
          if (arry[1] === undefined) {
            // const arry2 = arry[0].split("-");
            // console.log('arry2', arry2)
            // if (arry2[3] === undefined) {
            //   console.log('arry2 if', arry2)
            //   this.$router.push("/join" + "/?uuid=" + arry + "&T=" + 1).catch(() => { });
            // } else {
            //   console.log('arry2 else', arry2)
            //   const uuidlink = arry2[0] + "-" + arry2[1] + "-" + arry2[2] + arry2[3];
            //   console.log('uuidlink', uuidlink)
            // }
              this.$router
                .push("/join" + "/?uuid=" + arry + "&T=" + 1)
                .catch(() => { });
          // } else {
          //   const arry2 = arry[1].split("-");
          //   if (arry2[3] === undefined) {
          //     this.$router
          //       .push("/join" + "/?uuid=" + arry[1] + "&T=" + 1)
          //       .catch(() => { });
          //   } else {
          //     const uuidlink = arry2[0] + "-" + arry2[1] + "-" + arry2[2] + arry2[3];
          //     this.$router
          //       .push("/join" + "/?uuid=" + uuidlink + "&T=" + 1)
          //       .catch(() => { });
          //   }
          }
        } else {
          const idtest = new URL(this.coppylink).searchParams.get("uuid");
          console.log('idtest', idtest)
          this.$router.push("/join" + "/?uuid=" + idtest + "&T=" + 1).catch(() => { });
        }
        // console.log('this.coppylink', this.coppylink)
        // const idtest = new URL(this.coppylink).searchParams.get('uuid')
        // console.log('idtest', idtest)
        // var setString1 = this.coppylink.substring(36);
        // console.log('coppylink', setString1)
        // this.$router.push(this.coppylink + '&T=' + 1).catch(() => {})

        // this.$router.push('/join' + '/?uuid=' + this.coppylink + '&T=' + 1).catch(() => {})
      }
    },
  },
};
</script>

<style scoped>
.article {
  position: relative;
  z-index: 1;
}

.article:before {
  content: " ";
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  z-index: -1;
  background: url("~@/assets/Image.png");
  background-size: cover;
}

.articleM {
  position: relative;
  z-index: 1;
}

.articleM:before {
  content: " ";
  position: absolute;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  z-index: -1;
  background: url("~@/assets/Image.png");
  background-size: cover;
}

.articleXL {
  position: relative;
  z-index: 1;
}

.articleXL:before {
  content: " ";
  position: absolute;
  top: -100px;
  left: 0;
  right: 0;
  width: 100%;
  height: 1200px;
  opacity: 0.3;
  z-index: -1;
  background: url("~@/assets/Image.png");
  background-size: cover;
}

.v-list {
  padding: 0px 0 !important;
}

.v-list-item {
  min-height: 0px !important;
  padding: 0px 0 !important;
}

.tile:hover {
  background: #0a4da3;
}

/* button {
  color: white;
  text-decoration: none;
  font-size: 25px;
  border: none;
  background: none;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
} */

/* button::before {
  margin-left: auto;
} */

/* button::after, button::before {
  content: '';
  width: 0%;
  height: 2px;
  background: #ffffff;
  display: block;
  transition: 0.5s;
}

button:hover::after, button:hover::before {
  width: 100%;
} */
.input-container {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 485px;
  height: 38px;
}

.input-container>span,
.input-container .input {
  white-space: nowrap;
  display: block;
}

.input-container>span,
.input-container .input:first-child {
  border-radius: 6px 0 0 6px;
}

.input-container>span,
.input-container .input {
  border-radius: 0 6px 6px 0;
}

.input-container>span,
.input-container .input {
  margin-left: -1px;
}

.input-container .input {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  width: 1%;
  margin-top: 0;
  margin-bottom: 0;
}

.input-container span {
  text-align: center;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 25px;
  color: #ffffff;
  background: #0043df;
  border: 1px solid #cdd9ed;
  font-weight: bold;
  transition: background 0.3s ease, border 0.3s ease, color 0.3s ease;
}

.input-container:focus-within>span {
  color: #fff;
  background-color: #0c90e296;
  border-color: #148cd1;
}

.input {
  display: block;
  width: 100%;
  padding: 8px 16px;
  line-height: 25px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 6px;
  -webkit-appearance: none;
  color: #99a3ba;
  border: 1px solid #cdd9ed;
  background: #fff;
  transition: border 0.3s ease;
}

.input::placeholder {
  color: #cbd1dc;
}

.input:focus {
  outline: none;
  border-color: #148cd1;
}

.no-uppercase {
  text-transform: none;
}
</style>
